import type { SupportedLocale } from "@/lib/i18n/config";
import {
  isPublicLocalePathname,
  localizePublicHref,
} from "@/lib/i18n/public-routes";
import { stripLocaleFromPathname } from "@/lib/i18n/routing";

const normalizeSearch = (search: string | null | undefined) => {
  if (!search) {
    return "";
  }

  return search.startsWith("?") ? search : `?${search}`;
};

export const resolveLocaleChangeHref = (
  pathname: string,
  locale: SupportedLocale,
  search: string | null | undefined = ""
) => {
  const { pathnameWithoutLocale } = stripLocaleFromPathname(pathname);
  const normalizedSearch = normalizeSearch(search);
  const canonicalHref = `${pathnameWithoutLocale}${normalizedSearch}`;

  if (isPublicLocalePathname(pathnameWithoutLocale)) {
    return localizePublicHref(locale, canonicalHref);
  }

  return canonicalHref;
};
